module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tabs"
    }
  }, [_c('div', {
    staticClass: "tabs-active-style",
    style: ({
      'width': _vm.width + 'px'
    }),
    attrs: {
      "id": "tabs-active-style"
    }
  }, [_c('span')]), _vm._v(" "), _c('ul', {
    staticClass: "boss-tabs"
  }, _vm._l((_vm.tabs), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "boss-tabs-item",
      class: {
        'tabs-item-active': _vm.value === item.active
      },
      on: {
        "touchstart": function($event) {
          return _vm.touchstartFn(item.active, index)
        },
        "click": function($event) {
          return _vm.touchstartFn(item.active, index)
        }
      }
    }, [(item.icon) ? _c('i', {
      staticClass: "boss",
      class: item.icon
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "boss-tabs-item-span"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c9896de","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/tabs/tabs.vue
// module id = 511
// module chunks = 0